import { ArrowRight, Sparkles } from "lucide-react";
import EligibilityForm from "./EligibilityForm";

export default function FinalCTA() {
  return (
    <section id="form-final" className="pc-bg">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7 lg:pt-2">
            <div
              className="flex items-center gap-2.5 sm:gap-3 w-full min-w-0"
              data-testid="final-badge"
            >
              <span className="tricolor-stripe shrink-0" aria-hidden />
              <div className="inline-flex min-w-0 flex-1 items-center gap-2 rounded-full border border-[var(--pc-blue)]/15 bg-[var(--pc-blue-soft)] px-3 py-1.5 sm:px-3.5 sm:py-1.5 text-left text-[11.5px] sm:text-[12.5px] font-medium leading-snug pc-text-blue">
                <Sparkles className="h-3.5 w-3.5 shrink-0" strokeWidth={2.4} aria-hidden />
                <span className="min-w-0">Premier déposé, premier servi</span>
              </div>
            </div>

            <h2 className="display-2 pc-text-ink text-balance mt-7" data-testid="final-h2">
              Le dispositif <span className="font-serif-emph">ne durera pas</span>.
              <span className="block pc-text-muted mt-2">Votre dossier, lui, peut commencer aujourd'hui.</span>
            </h2>

            <p className="mt-7 pc-text-muted text-[18px] sm:text-[19.5px] leading-[1.55] max-w-xl text-pretty">
              Le FIPU est un fonds limité, traité dans l'ordre d'arrivée des dossiers. Il vaut mieux savoir maintenant si vous êtes éligible.
            </p>

            <div className="mt-10 hidden lg:flex items-center gap-6">
              <a href="#form-final" className="btn-primary inline-flex items-center justify-center gap-2">
                Vérifier mon éligibilité
                <ArrowRight className="w-4 h-4" />
              </a>
              <span className="text-[14px] pc-text-muted">Réponse en 30 secondes · Sans engagement</span>
            </div>
          </div>

          <div className="lg:col-span-5">
            <EligibilityForm sourceSection="final" testIdPrefix="form-final" />
          </div>
        </div>
      </div>
    </section>
  );
}
